import { render } from "./Gallery.vue?vue&type=template&id=74781190"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74781190"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74781190', __exports__)) {
    api.reload('74781190', __exports__)
  }
  
  module.hot.accept("./Gallery.vue?vue&type=template&id=74781190", () => {
    api.rerender('74781190', render)
  })

}


export default __exports__